export const valueProposition = {
  title: "Why choose Gándara?",
  subtitle: "Three fundamental pillars that define our educational approach",
  items: {
    montessori: {
      title: "Active Montessori Pedagogy",
      description: "Prepared environments, manipulative materials and respect for individual learning rhythms"
    },
    nature: {
      title: "Nature and Spaces",
      description: "More than 5,000 m² of facilities with garden, green areas and constant connection with natural environment"
    },
    community: {
      title: "Educational Community",
      description: "Small ratios (1:12) and close accompaniment that allows personalized attention"
    }
  }
};
